import React, { useState } from 'react';
import { Formik, FormikHelpers } from 'formik';

import { FormHelperText } from '@material-ui/core';
import { Button, FormTextField } from '../../atoms';
import { ErrorObject, BaseFormProps, EditFamilyMemberProps } from '../../../types';
import { OffenderIdentifierType } from '../../../enums';
import { adminFamilyMemberValidationSchema } from '../../../validators';

export const EditFamilyMembersForm: React.FC<BaseFormProps<EditFamilyMemberProps>> = ({
  initialValues,
  submitForm,
  onSuccess,
}) => {
  const [generalError, setGeneralError] = useState(null);
  const _handleFormSubmitError = (
    error: ErrorObject,
    actions: FormikHelpers<EditFamilyMemberProps>,
  ) => {
    actions.setSubmitting(false);
    setGeneralError(error.detail);
  };

  const _handleSubmission = (
    formData: EditFamilyMemberProps,
    actions: FormikHelpers<EditFamilyMemberProps>,
  ) => {
    submitForm(formData)
      .then(() => {
        onSuccess();
      })
      .catch((error: ErrorObject) => {
        _handleFormSubmitError(error, actions);
      })
      .finally(() => actions.setSubmitting(false));
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validateOnBlur
        validateOnChange={false}
        onSubmit={_handleSubmission}
        validationSchema={adminFamilyMemberValidationSchema}
        enableReinitialize
      >
        {({
          handleSubmit,
          isSubmitting,
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
          handleReset,
          setFieldValue,
        }) => (
          <form
            onReset={handleReset}
            onSubmit={handleSubmit}
            className="flex flex-auto flex-col gap-3 py-1 mx-7"
          >
            <p className="flex justify-center auth-heading text-center">Edit Family Member</p>
            {generalError && <FormHelperText error>{generalError}</FormHelperText>}
            <p className="flex justify-start text-left text-xs font-bold">First Name:</p>
            <FormTextField
              variableName="firstName"
              placeholder="First Name"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              required
              className="w-96"
            />
            <p className="flex justify-start text-left text-xs font-bold">Last Name:</p>
            <FormTextField
              variableName="lastName"
              placeholder="Last Name"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              required
              className="w-96"
            />
            <p className="flex justify-start text-left text-xs font-bold">Identification Type:</p>
            <select
              name="offenderIdentifierType"
              id="offenderIdentifierType"
              value={values?.offenderIdentifier?.identifierType}
              onChange={(e) =>
                setFieldValue('offenderIdentifier.identifierType', Number(e.target.value))
              }
            >
              <option value={OffenderIdentifierType.SaIdNumber}>SA ID</option>
              <option value={OffenderIdentifierType.Trn}>Trn</option>
            </select>
            <p className="flex justify-start text-left text-xs font-bold">ID/TRN Number:</p>
            <FormTextField
              variableName="offenderIdentifier.value"
              placeholder="ID/TRN"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              required
              className="w-96"
            />

            <Button
              isLoading={isSubmitting}
              onClick={handleSubmit}
              className="w-4/5 bg-secondary hover:bg-secondary-dark text-white text-base self-center my-7"
            >
              Edit Family Member
            </Button>
          </form>
        )}
      </Formik>
    </>
  );
};
